import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'types/state';

export const selectMemberCode = createSelector(
  (state: GlobalState) => state.memberCode,
  (memberCode) => memberCode.code ?? '',
);

export const selectMemberCodeDetails = createSelector(
  (state: GlobalState) => state.memberCode,
  (memberCode) => memberCode,
);

export const selectMemberCodeStatus = createSelector(
  (state: GlobalState) => state.memberCode,
  (memberCode) => memberCode.status,
);
